import { Field } from "react-final-form";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import LinkIcon from "mdi-react/LinkIcon";
import FormTextField from "@components/Shared/FormTextField";
import { useTranslation } from "react-i18next";
import IFormProps from "@interfaces/Shared/formProps";
import renderSelectField from "@easydev/form/Select";
import useStates from "@mappers/Shared/getState.mapper";
import FormatTitleIcon from "mdi-react/FormatTitleIcon";
import TextLongIcon from "mdi-react/TextLongIcon";
import ButtonContainer from "@components/ButtonContainer";

const CreateForm = ({ handleSubmit }: IFormProps) => {
  const { GetStates } = useStates();
  const { t } = useTranslation(["core"]);

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.name")}</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <AccountOutlineIcon />
          </div>
          <Field
            name="name"
            component={FormTextField}
            type="textbox"
            placeholder={t("core:common.name")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.connectText")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormatTitleIcon />
          </div>
          <Field
            name="connectText"
            component={FormTextField}
            type="text"
            placeholder={t("hackatao:common.connectText")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.winnerText")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormatTitleIcon />
          </div>
          <Field
            name="winnerText"
            component={FormTextField}
            type="text"
            placeholder={t("hackatao:common.winnerText")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.notWinnerText")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormatTitleIcon />
          </div>
          <Field
            name="notWinnerText"
            component={FormTextField}
            type="text"
            placeholder={t("hackatao:common.notWinnerText")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.alreadyClaimedText")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormatTitleIcon />
          </div>
          <Field
            name="alreadyClaimedText"
            component={FormTextField}
            type="text"
            placeholder={t("hackatao:common.alreadyClaimedText")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.loadingText")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormatTitleIcon />
          </div>
          <Field
            name="loadingText"
            component={FormTextField}
            type="text"
            placeholder={t("hackatao:common.loadingText")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.successText")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormatTitleIcon />
          </div>
          <Field
            name="successText"
            component={FormTextField}
            type="text"
            placeholder={t("hackatao:common.successText")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.traitsPerWallet")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormatTitleIcon />
          </div>
          <Field
            name="traitsPerWallet"
            component={FormTextField}
            type="textbox"
            placeholder={t("hackatao:common.traitsPerWallet")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.whiteList")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <TextLongIcon />
          </div>
          <Field
            name="whitelist"
            component="textarea"
            type="text"
            placeholder={t("hackatao:common.whiteList")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.buttonText")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormatTitleIcon />
          </div>
          <Field
            name="buttonText"
            component={FormTextField}
            type="text"
            placeholder={t("hackatao:common.buttonText")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.linkImageLeft")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <LinkIcon />
          </div>
          <Field
            name="linkImageLeft"
            component={FormTextField}
            type="text"
            placeholder={t("core:common.url_image")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("hackatao:common.linkImageRight")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <LinkIcon />
          </div>
          <Field
            name="linkImageRight"
            component={FormTextField}
            type="text"
            placeholder={t("core:common.url_image")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.state")}</span>
        <div className="form__form-group-field">
          <Field
            name="state"
            component={renderSelectField}
            type="text"
            placeholder={`${t("core:common.select_placeholder")} ${t(
              "core:common.state"
            )}`}
            options={GetStates()}
            isAboveError
          />
        </div>
      </div>

      <ButtonContainer />
    </form>
  );
};

export default CreateForm;
